import { create } from "zustand";
import { ISwapSecurity } from "@/lib/interfaces and Enums/ENUMSwapSecurity";
import { ReferenceDataStatus } from "@/lib/interfaces and Enums/ENUMReferenceDataStatus";

// LQC-2939 - template swaps for the Swap / Swaption pickers. ~750KB, so fetched only when
// a swap ticket opens, never on app load or idle.

type State = {
  swapSecurities: ISwapSecurity[];
  swapSecuritiesStatus: ReferenceDataStatus;
  swapSecuritiesError: string;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setSwapSecurities: (swapSecurities: ISwapSecurity[]) => void;
  // eslint-disable-next-line no-unused-vars
  setSwapSecuritiesStatus: (status: ReferenceDataStatus) => void;
  // eslint-disable-next-line no-unused-vars
  setSwapSecuritiesError: (message: string) => void;
  clearSwapSecurities: () => void;
};

const swapSecuritiesStore = create<State & Action>((set) => ({
  swapSecurities: [],
  swapSecuritiesStatus: ReferenceDataStatus.Idle,
  swapSecuritiesError: "",

  setSwapSecurities: (swapSecurities) =>
    set({
      swapSecurities,
      swapSecuritiesStatus: ReferenceDataStatus.Loaded,
      swapSecuritiesError: "",
    }),
  setSwapSecuritiesStatus: (swapSecuritiesStatus) => set({ swapSecuritiesStatus }),
  setSwapSecuritiesError: (swapSecuritiesError) =>
    set({ swapSecuritiesError, swapSecuritiesStatus: ReferenceDataStatus.Error }),
  clearSwapSecurities: () =>
    set({
      swapSecurities: [],
      swapSecuritiesStatus: ReferenceDataStatus.Idle,
      swapSecuritiesError: "",
    }),
}));

export default swapSecuritiesStore;
